var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 3.125C27.125 1.68125 25.9437 0.5 24.5 0.5H3.5C2.05625 0.5 0.875 1.68125 0.875 3.125V18.875C0.875 20.3188 2.05625 21.5 3.5 21.5H24.5C25.9437 21.5 27.125 20.3188 27.125 18.875V3.125ZM24.5 3.125L14 9.6875L3.5 3.125H24.5ZM24.5 18.875H3.5V5.75L14 12.3125L24.5 5.75V18.875Z",
    fill: "#101729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.a2d3ed71e0c824df737391e452a1c55d.svg";
export { ForwardRef as ReactComponent };